// Un mismo teléfono puede pedir para varios negocios (el dueño de dos despensas): elige para cuál va a pedir. Se
// puede cambiar después desde Perfil. Cada negocio tiene su propio carrito.
import { Icono } from '@reparto/ui';
import { useNavigate } from 'react-router';
import { Pantalla } from '../componentes/Marco';
import { elegirNegocio, useCuenta } from '../datos/cuenta';
import { claveCarrito } from '../datos/estado-carrito';
import { leer } from '../datos/almacen';
import type { Carrito } from '../datos/carrito';

export function ElegirNegocio() {
  const perfil = useCuenta((s) => s.perfil);
  const elegido = useCuenta((s) => s.negocioId);
  const navegar = useNavigate();
  const clientes = perfil?.clientes ?? [];
  return (
    <Pantalla
      titulo="¿Para qué negocio pedís?"
      subtitulo={perfil?.empresa.nombre}
      volver={elegido ? '/perfil' : undefined}
      sinNav={!elegido}
    >
      <div className="px-4 py-5">
        <p className="mb-4 text-stone-700">
          Tu número está anotado en {clientes.length} negocios. Elegí uno; después lo podés cambiar.
        </p>
        <ul className="flex flex-col gap-3">
          {clientes.map((c) => {
            const guardado = leer<Carrito>(claveCarrito(c.id));
            const enCarrito = guardado?.lineas?.length ?? 0;
            const actual = c.id === elegido;
            return (
              <li key={c.id}>
                <button
                  type="button"
                  onClick={() => {
                    elegirNegocio(c.id);
                    navegar('/', { replace: true });
                  }}
                  aria-current={actual ? 'true' : undefined}
                  className={
                    'flex w-full items-center gap-4 rounded-3xl border-2 bg-white p-4 text-left transition-colors hover:bg-primary-50 ' +
                    'focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-600 ' +
                    (actual ? 'border-primary-600' : 'border-stone-200')
                  }
                >
                  <span className="grid h-14 w-14 shrink-0 place-items-center rounded-2xl bg-primary-50 text-primary-700">
                    <Icono nombre="storefront" tamano={30} />
                  </span>
                  <span className="min-w-0 flex-1">
                    <span className="block text-lg leading-snug font-bold text-stone-900">{c.nombre}</span>
                    {c.direccion ? <span className="block text-[15px] text-stone-600">{c.direccion}</span> : null}
                    {enCarrito ? (
                      <span className="mt-1 inline-flex items-center gap-1 text-[15px] font-medium text-primary-800">
                        <Icono nombre="shopping_cart" tamano={18} />
                        Tenés {enCarrito} {enCarrito === 1 ? 'artículo' : 'artículos'} en el pedido
                      </span>
                    ) : null}
                  </span>
                  <Icono
                    nombre={actual ? 'check_circle' : 'chevron_right'}
                    relleno={actual}
                    className="shrink-0 text-primary-700"
                    tamano={28}
                  />
                </button>
              </li>
            );
          })}
        </ul>
      </div>
    </Pantalla>
  );
}
